import { CommercialBookingPreview } from "@/interfaces/CommercialBooking";
import api from "./api";

export const commercialBookingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCommercialBooking: build.query<
      CommercialBookingPreview,
      { companyId: string; date: string; meetingId?: string }
    >({
      query: ({ companyId, date, meetingId }) => ({
        url: `/companies/${companyId}/commercial-booking`,
        params: { date, meetingId },
      }),
      providesTags: [{ type: "CommercialBooking", id: "LIST" }],
    }),
  }),
});
export const { useGetCommercialBookingQuery } = commercialBookingApi;
